import React, { FC } from 'react';

import { Typography } from '@mui/material';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import ChevronLeftIcon from '../../../../assets/icons/ChevronLeftIcon';
import ChevronRightIcon from '../../../../assets/icons/ChevronRightIcon';
import { colorsPalette, useIsWidthUp } from '../../../../theme';
import useStyles from './styles';

interface PathwayPlayerMenuProps {
  videosCount?: number;
  videoPosition: number;
  prevVideoLink?: string;
  nextVideoLink?: string;
}

const PathwayPlayerMenu: FC<PathwayPlayerMenuProps> = ({
  videosCount,
  videoPosition,
  prevVideoLink,
  nextVideoLink,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const isMobile = !useIsWidthUp('md');
  const isFirst = videoPosition === 1;
  const isLast = videoPosition === videosCount;

  return (
    <div className={classes.wrapper} data-testid="pathwayPlayerMenu">
      <div className={classes.videosSwitcher}>
        <Typography
          className={cx(
            classes.videosTitle,
            isFirst && classes.leftVideosTitlePlaceholder,
            isLast && classes.rightVideosTitlePlaceholder,
          )}
        >
          {!isMobile && t('common.videoCap')} {videoPosition}/{videosCount}
        </Typography>
        <div className={classes.navWrap}>
          {!isFirst && (
            <Link
              className={cx(classes.iconLink, isLast && classes.leftVideosTitlePlaceholder)}
              to={prevVideoLink}
              data-testid="prevVideo"
            >
              <div className={classes.iconWrap}>
                <ChevronLeftIcon className={classes.icon} color={colorsPalette.blue} />
              </div>
              <div className={classes.leftIcon}>
                {t(isMobile ? 'page.video.prev' : 'page.video.previousVideo')}
              </div>
            </Link>
          )}
          {!isLast && (
            <Link
              className={cx(classes.iconLink, isFirst && classes.rightVideosTitlePlaceholder)}
              to={nextVideoLink}
              data-testid="lastVideo"
            >
              <div className={classes.rightIcon}>
                {t(isMobile ? 'page.video.next' : 'page.video.nextVideo')}
              </div>
              <div className={classes.iconWrap}>
                <ChevronRightIcon className={classes.icon} color={colorsPalette.blue} />
              </div>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default PathwayPlayerMenu;
